import EraType from "@/roc/era/EraType";
import { useLayoutStore } from "@/roc/stores/LayoutStore";
import { useWonderStore } from "@/roc/stores/WonderStore";
import { applyWonderSynergies } from "@/components/Bonuses/Calculator/Bonus";
import ProductionOutputType from "@/roc/effects/Production/ProductionOutputType";
import PassiveProduction from "@/roc/effects/Production/PassiveProduction";
import { getCurrentEraGoods, getPreviousEraGoods } from "@/roc/building/workshop/WorkshopOutput";
class ProductionBonusCalculator {
    static calculate(playerEra) {
        const lytStore = useLayoutStore();
        const wonderStore = useWonderStore();
        const result = [];
        const productions = {};
        lytStore.mapBuildings((building, buildingId) => {
            for (let i = 0; i < building.effects.count(); i++) {
                const effect = building.effects.getEffect(i);
                if (effect instanceof PassiveProduction) {
                    const amount = effect.production(building.level || 1, building.era || playerEra);
                    if (amount) {
                        productions[effect.output.output] = (productions[effect.output.output] || 0) + (amount.amount / amount.duration);
                    }
                }
            }
            return true;
        });
        wonderStore.mapWonders((wonder, config) => {
            for (let i = 0; i < wonder.effects.count(); i++) {
                if (config.active) {
                    const effect = wonder.effects.getEffect(i);
                    if (effect instanceof PassiveProduction) {
                        const amount = effect.production(config.level, EraType.stoneAge /*Note: Era is unused for wonders*/);
                        if (amount) {
                            productions[effect.output.output] = (productions[effect.output.output] || 0) + (amount.amount / amount.duration);
                            applyWonderSynergies(wonder, config.level, i, (effect, amount) => {
                                productions[effect.output.output] += amount;
                            });
                        }
                    }
                }
            }
            return true;
        });
        for (const i in productions) {
            const pa = productions[i] * 24 * 60 * 60;
            const amount = pa.toFixed(2).endsWith('.00') ? pa.toFixed(0) : pa.toFixed(2);
            if (parseFloat(amount) <= 0) {
                continue;
            }
            switch (parseInt(i)) {
                case ProductionOutputType.GOLD:
                    result.push({
                        icon: 'Coin',
                        description: `Produce <b>${amount}</b> of <b>Gold</b> per day.`,
                    });
                    break;
                case ProductionOutputType.FOOD:
                    result.push({
                        icon: 'Food',
                        description: `Produce <b>${amount}</b> of <b>Food</b> per day.`,
                    });
                    break;
                case ProductionOutputType.RESEARCH_POINTS:
                    result.push({
                        icon: 'RP',
                        description: `Produce <b>${amount}</b> <b>Research Point${pa > 1 ? 's' : ''}</b> per day.`,
                    });
                    break;
                case ProductionOutputType.GEARS:
                    result.push({
                        icon: 'Gears',
                        description: `Produce <b>${amount}</b> of <b>Gear${pa > 1 ? 's' : ''}</b> per day.`,
                    });
                    break;
                case ProductionOutputType.WONDER_HELP_REQUEST:
                    result.push({
                        icon: 'WonderHelpRequest',
                        description: `Produce <b>${amount}</b> of <b>Wonder Help Request${pa > 1 ? 's' : ''}</b> per day.`,
                    });
                    break;
                case ProductionOutputType.WONDER_HELP_ACTION:
                    result.push({
                        icon: 'WonderHelpAction',
                        description: `Produce <b>${amount}</b> of <b>Wonder Help Action${pa > 1 ? 's' : ''}</b> per day.`,
                    });
                    break;
                case ProductionOutputType.TREASURE_HUNT_ATTEMPT:
                    result.push({
                        icon: 'Compass',
                        description: `Produce <b>${amount}</b> of <b>Treasure Hunt Attempt${pa > 1 ? 's' : ''}</b> per day.`,
                    });
                    break;
                case ProductionOutputType.ALL_PREVIOUS_ERA_GOODS:
                    if (playerEra !== EraType.stoneAge && playerEra !== EraType.bronzeAge) {
                        const goods = getPreviousEraGoods(playerEra);
                        for (let i = 0; i < goods.length; i++) {
                            result.push({
                                icon: goods[i],
                                description: `Produce <b>${amount}</b> of <b>${goods[i].replace('_', ' ')}</b> per day.`,
                            });
                        }
                    }
                    break;
                case ProductionOutputType.ALL_CURRENT_ERA_GOODS:
                    if (playerEra !== EraType.stoneAge) {
                        const goods = getCurrentEraGoods(playerEra);
                        for (let i = 0; i < goods.length; i++) {
                            result.push({
                                icon: goods[i],
                                description: `Produce <b>${amount}</b> of <b>${goods[i].replace('_', ' ')}</b> per day.`,
                            });
                        }
                    }
                    break;
                // Note: We have no way of determining which goods are secondary/tertiary
                // case ProductionOutputType.CURRENT_ERA_PRIMARY_GOODS:
                // case ProductionOutputType.CURRENT_ERA_SECONDARY_GOODS:
                // case ProductionOutputType.CURRENT_ERA_TERTIARY_GOODS:
                // case ProductionOutputType.PREVIOUS_ERA_PRIMARY_GOODS:
                // case ProductionOutputType.PREVIOUS_ERA_SECONDARY_GOODS:
                // case ProductionOutputType.PREVIOUS_ERA_TERTIARY_GOODS:
                // case ProductionOutputType.CHEST:
                // case ProductionOutputType.RANDOM_BARRACKS_REFILL:
                // case ProductionOutputType.BARRACKS_REFILL_SELECTION_KIT:
                // case ProductionOutputType.RANDOM_MERCENARY_COMMANDER:
                // case ProductionOutputType.MERCENARY_COMMANDER_SELECTION_KIT:
                // case ProductionOutputType.NEGOTIATION_JOKER:
                // case ProductionOutputType.EVENT_PUZZLE_PIECE:
                // case ProductionOutputType.SQUAD_HEALING_ITEM:
                // case ProductionOutputType.COMPLETE_SQUAD_HEALING_ITEM:
                // case ProductionOutputType.REGULAR_PUZZLE_PIECE:
                // case ProductionOutputType.RANDOM_PREVIOUS_ERA_GOODS:
                // case ProductionOutputType.RANDOM_CURRENT_ERA_GOODS:
                // case ProductionOutputType.RANDOM_GOODS:
                // case ProductionOutputType.EVENT_CURRENCY:
                //   break;
            }
        }
        return result;
    }
}
export default ProductionBonusCalculator;
